// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunks/" + ({"200":"insights","275":"search-insights","328":"postMetrics","524":"app"}[chunkId] || chunkId) + "-" + {"200":"94d222fc","275":"1e2b075b","328":"705e99fd","482":"cfd4d7d3","524":"a3ff226e"}[chunkId] + ".css";
};